import { render, staticRenderFns } from "./invTabPaneTem.vue?vue&type=template&id=0d196fa6"
import script from "./invTabPaneTem.vue?vue&type=script&lang=js"
export * from "./invTabPaneTem.vue?vue&type=script&lang=js"
import style0 from "./invTabPaneTem.vue?vue&type=style&index=0&id=0d196fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports